<template>
    <div>
        Jednotky
        <o3-select
            v-model="selected"
            :options="options"
            :name="name"
            :length-type="lengthType"
            @change="$emit('change')"
        />
        <input-error v-if="v" :v="v" :name="name"/>
    </div>
</template>

<script>
import autocompleteMixin from '@/components/Autocomplete/autocomplete.mixin';

export default {
    name:     'UnitAutocomplete',
    mixins:   [autocompleteMixin],
    props:    {
        name: {
            type:     String,
            required: false,
            default:  () => 'building'
        }
    },
    computed: {
        options() {
            return this.$store.getters['projects/project/units/unitsForAutocomplete'];
        }
    }
};
</script>
